enum CardEntryMethod {
  Unknown = 0,
  Swipe,
  Chip,
  Contactless,
  ManuallyEntered,
  Scan,
  ApplePay,
  GooglePay,
  ProvidedExternally,
  CardOnFile,
}

export { CardEntryMethod };
